import Component from '../core/Component'
import CursorTrigger from '../meta/CursorTrigger'

const defaults = {
    symbol: 'right'
}

export default class CursorRegion extends Component {
    constructor(element) {
        super(element, defaults)
        this.cursor = null

        if (this.element.dataset.symbol) {
            this.options.symbol = this.element.dataset.symbol
        }
    }

    prepare() {
        this.cursor = new CursorTrigger(this.element, this.options)
    }

    destroy() {
        if (this.cursor) {
            this.cursor.destroy()
            this.cursor = null
        }
    }
}